import { render, staticRenderFns } from "./goods-sku-ope.vue?vue&type=template&id=07d48b1f&scoped=true&"
import script from "./goods-sku-ope.vue?vue&type=script&lang=js&"
export * from "./goods-sku-ope.vue?vue&type=script&lang=js&"
import style0 from "./goods-sku-ope.vue?vue&type=style&index=0&id=07d48b1f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d48b1f",
  null
  
)

export default component.exports